(function () {
  if (window.__kajynBeatPlayerInit) return;
  window.__kajynBeatPlayerInit = true;

  const formatTime = (rawSeconds) => {
    const seconds = Number.isFinite(rawSeconds) ? Math.max(rawSeconds, 0) : 0;
    const minutes = Math.floor(seconds / 60);
    const remainder = Math.floor(seconds % 60);
    return `${minutes}:${String(remainder).padStart(2, "0")}`;
  };

  const initBeatPlayer = () => {
    const dataNode = document.getElementById("beat-player-data");
    const playerBar = document.getElementById("beatPlayerBar");
    const audio = document.getElementById("beat-audio-player");
    const albumCoverImage = document.getElementById("sp-cover");
    const prevButton = document.getElementById("playerPrev");
    const playPauseButton = document.getElementById("playerPlayPause");
    const nextButton = document.getElementById("playerNext");
    const closeButton = document.getElementById("playerClose");
    const playIcon = playPauseButton?.querySelector(".play-icon") || null;
    const pauseIcon = playPauseButton?.querySelector(".pause-icon") || null;
    const trackName = document.querySelector(".player-track-name");
    const trackMeta = document.querySelector(".player-track-meta");
    const progressBar = document.getElementById("playerProgressBar");
    const progressFill = document.getElementById("playerProgressFill");
    const progressTooltip = document.getElementById("progressTooltip");
    const playerTime = document.querySelector(".player-time");
    const volumeButton = document.getElementById("playerVolumeBtn");
    const volumeIconNormal = document.getElementById("volume-icon-normal");
    const volumeIconMute = document.getElementById("volume-icon-mute");
    const volumeRange = document.getElementById("playerVolumeRange");
    const playerCartButton = document.getElementById("playerCartBtn");
    const playerCartPrice = document.getElementById("playerCartPrice");
    const rows = Array.from(document.querySelectorAll(".beat-item"));
    const beatStorePage = document.querySelector(".beat-store-page");

    if (
      !dataNode ||
      !playerBar ||
      !audio ||
      !albumCoverImage ||
      !prevButton ||
      !playPauseButton ||
      !nextButton ||
      !closeButton ||
      !trackName ||
      !trackMeta ||
      !progressBar ||
      !progressFill ||
      !playerTime ||
      !volumeButton ||
      !volumeIconNormal ||
      !volumeIconMute ||
      !playerCartButton ||
      !playerCartPrice ||
      !rows.length
    ) {
      return;
    }

    let playerData = { tracks: {}, previewCount: 0 };

    try {
      playerData = JSON.parse(dataNode.textContent || "{}");
    } catch (error) {
      console.error("Beat player data could not be parsed.", error);
      return;
    }

    let activeRow = null;
    let activeTrack = null;
    let lastVolume = 0.8;
    let isDraggingProgress = false;
    let closeHideTimer = null;
    let isClosingPlayer = false;
    let reopenGuardUntil = 0;
    const PLAYER_VISIBILITY_DURATION = 260;
    const PLAYER_REOPEN_GUARD_MS = 360;

    audio.preload = "metadata";
    audio.playsInline = true;
    audio.volume = lastVolume;

    const getVisiblePlayableRows = () =>
      rows.filter((row) => {
        const isVisible = !row.hidden && row.style.display !== "none";
        return isVisible && Boolean(playerData.tracks?.[row.dataset.productId]?.previewUrl);
      });

    const getCurrentRowIndex = () => getVisiblePlayableRows().indexOf(activeRow);

    const openPlayer = () => {
      if (closeHideTimer) {
        window.clearTimeout(closeHideTimer);
        closeHideTimer = null;
      }

      isClosingPlayer = false;
      playerBar.hidden = false;
      playerBar.classList.remove("is-closing");

      // Mobile Safari can skip the transition if hidden and active flip in the same frame.
      playerBar.getBoundingClientRect();

      window.requestAnimationFrame(() => {
        beatStorePage?.classList.add("beat-store-page--player-visible");
        playerBar.classList.add("active");
      });
    };

    const closePlayer = () => {
      if (playerBar.hidden || isClosingPlayer) return;

      isClosingPlayer = true;
      reopenGuardUntil = window.performance.now() + PLAYER_REOPEN_GUARD_MS;
      playerBar.classList.add("is-closing");
      closeButton.blur();
      audio.pause();
      audio.removeAttribute("src");
      delete audio.dataset.previewUrl;
      audio.load();
      activeRow = null;
      activeTrack = null;
      isDraggingProgress = false;
      isDraggingVolume = false;
      playerBar.classList.remove("active");
      if (progressFill) progressFill.style.transform = "scaleX(0)";
      playerTime.textContent = "0:00 / 0:00";
      updatePlayIcons(false);
      updateVolumeIcon();
      syncButtons();
      syncActiveRow();

      if (closeHideTimer) {
        window.clearTimeout(closeHideTimer);
      }

      closeHideTimer = window.setTimeout(() => {
        playerBar.hidden = true;
        playerBar.classList.remove("is-closing");
        beatStorePage?.classList.remove("beat-store-page--player-visible");
        isClosingPlayer = false;

        closeHideTimer = null;
      }, PLAYER_VISIBILITY_DURATION);
    };

    const updatePlayIcons = (isPlaying) => {
      if (playIcon) playIcon.style.display = isPlaying ? "none" : "block";
      if (pauseIcon) pauseIcon.style.display = isPlaying ? "block" : "none";
    };

    const updateVolumeIcon = () => {
      const isMuted = audio.muted || audio.volume === 0;
      volumeIconNormal.style.display = isMuted ? "none" : "block";
      volumeIconMute.style.display = isMuted ? "block" : "none";
      volumeButton.setAttribute("aria-pressed", isMuted ? "true" : "false");
      volumeButton.setAttribute("aria-label", isMuted ? "Unmute volume" : "Mute volume");
    };

    const updateProgress = () => {
      const percentage = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
      progressFill.style.transform = `scaleX(${Math.max(0, Math.min(1, percentage / 100))})`;
    };

    const updateTimeDisplay = () => {
      playerTime.textContent = `${formatTime(audio.currentTime)} / ${formatTime(audio.duration)}`;
    };

    const syncActiveRow = () => {
      rows.forEach((row) => {
        row.classList.toggle("is-active", row === activeRow);
      });
    };

    const syncButtons = () => {
      const hasTrack = Boolean(activeTrack && audio.src);
      const currentIndex = getCurrentRowIndex();
      const visibleRows = getVisiblePlayableRows();
      playPauseButton.disabled = !hasTrack;
      prevButton.disabled = !hasTrack || currentIndex <= 0;
      nextButton.disabled = !hasTrack || currentIndex === -1 || currentIndex >= visibleRows.length - 1;
    };

    const syncPlayerUI = () => {
      if (isClosingPlayer) return;

      updatePlayIcons(!audio.paused && !audio.ended);
      updateTimeDisplay();
      updateProgress();
      updateVolumeIcon();
      syncButtons();
      syncActiveRow();
    };

    const updatePlayerMetaFromTrack = (track) => {
      if (track?.image) {
        albumCoverImage.src = track.image;
        albumCoverImage.alt = track.title || "";
        albumCoverImage.style.visibility = "visible";
      } else {
        albumCoverImage.removeAttribute("src");
        albumCoverImage.alt = "";
        albumCoverImage.style.visibility = "hidden";
      }

      trackName.textContent = track?.title || "—";

      const bpmText = track?.bpm ? `${track.bpm} BPM` : "";
      if (bpmText) {
        trackMeta.textContent = bpmText;
      } else {
        trackMeta.textContent = "—";
      }

      playerCartButton.href = track?.buyUrl || track?.url || "#";
      playerCartButton.hidden = !(track?.buyUrl || track?.url);
      playerCartPrice.textContent = track?.price || "—";
    };

    const loadRow = async (row, autoplay = true) => {
      if (isClosingPlayer || window.performance.now() < reopenGuardUntil) return false;
      if (!row?.dataset?.productId) return false;

      const track = playerData.tracks?.[row.dataset.productId];
      if (!track?.previewUrl) return false;

      const nextUrl = track.previewUrl;
      const isSameTrack = activeRow === row && audio.dataset.previewUrl === nextUrl;

      activeRow = row;
      activeTrack = track;
      openPlayer();
      updatePlayerMetaFromTrack(track);

      if (!isSameTrack) {
        audio.pause();
        audio.src = nextUrl;
        audio.dataset.previewUrl = nextUrl;
        audio.load();
        if (progressFill) progressFill.style.transform = "scaleX(0)";
        playerTime.textContent = "0:00 / 0:00";
      }

      if (autoplay) {
        try {
          await audio.play();
        } catch (error) {
          console.error("Beat preview playback failed.", error);
        }
      }

      syncPlayerUI();
      return true;
    };

    const playPrevious = async () => {
      const visibleRows = getVisiblePlayableRows();
      const currentIndex = visibleRows.indexOf(activeRow);
      if (currentIndex <= 0) return;
      await loadRow(visibleRows[currentIndex - 1], true);
    };

    const playNext = async () => {
      const visibleRows = getVisiblePlayableRows();
      const currentIndex = visibleRows.indexOf(activeRow);
      if (currentIndex === -1 || currentIndex >= visibleRows.length - 1) return;
      await loadRow(visibleRows[currentIndex + 1], true);
    };

    const applyVolume = (nextVolume) => {
      const volume = Math.max(0, Math.min(1, nextVolume));
      audio.muted = volume === 0;
      audio.volume = volume;
      if (volume > 0) lastVolume = volume;
      if (volumeRange) volumeRange.value = Math.round(volume * 100);
      syncPlayerUI();
    };

    const seekFromClientX = (clientX) => {
      const rect = progressBar.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      if (isFinite(audio.duration) && audio.duration > 0) {
        audio.currentTime = ratio * audio.duration;
      }
    };

    rows.forEach((row) => {
      row.addEventListener("click", (event) => {
        if (isClosingPlayer || window.performance.now() < reopenGuardUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (event.target.closest(".beat-tag, .beat-download, .beat-share, .beat-cart-btn, a, button, input, select, label")) {
          return;
        }

        const track = playerData.tracks?.[row.dataset.productId];
        if (!track?.previewUrl) return;

        if (activeRow === row && audio.dataset.previewUrl === track.previewUrl) {
          if (audio.paused) {
            audio.play().catch((error) => console.error("Beat preview playback failed.", error));
          } else {
            audio.pause();
          }
          syncPlayerUI();
          return;
        }

        loadRow(row, true);
      });
    });

    playPauseButton.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!activeTrack || !audio.src) return;

      if (audio.paused) {
        try {
          await audio.play();
        } catch (error) {
          console.error("Beat preview playback failed.", error);
        }
      } else {
        audio.pause();
      }

      syncPlayerUI();
    });

    prevButton.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      await playPrevious();
    });

    nextButton.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      await playNext();
    });

    closeButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      closePlayer();
    });

    progressBar.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      seekFromClientX(event.clientX);
    });

    progressBar.addEventListener("mousemove", (event) => {
      if (!progressTooltip) return;
      const rect = progressBar.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      const time = audio.duration ? ratio * audio.duration : 0;
      progressTooltip.textContent = formatTime(time);
      progressTooltip.style.left = `${event.clientX - rect.left}px`;
      progressTooltip.style.opacity = "1";
    });

    progressBar.addEventListener("mouseleave", () => {
      if (progressTooltip) progressTooltip.style.opacity = "0";
    });

    progressBar.addEventListener("pointerdown", (event) => {
      isDraggingProgress = true;
      progressBar.setPointerCapture?.(event.pointerId);
      seekFromClientX(event.clientX);
    });

    progressBar.addEventListener("pointermove", (event) => {
      if (!isDraggingProgress) return;
      seekFromClientX(event.clientX);
    });

    progressBar.addEventListener("pointerup", () => {
      isDraggingProgress = false;
    });

    progressBar.addEventListener("pointercancel", () => {
      isDraggingProgress = false;
    });

    if (volumeRange) {
      volumeRange.addEventListener("input", (event) => {
        event.stopPropagation();
        applyVolume(parseInt(event.target.value, 10) / 100);
      });
    }

    volumeButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (audio.muted || audio.volume === 0) {
        audio.muted = false;
        if (audio.volume === 0) audio.volume = lastVolume > 0 ? lastVolume : 0.8;
      } else {
        lastVolume = audio.volume;
        audio.muted = true;
      }
      syncPlayerUI();
    });

    document.addEventListener("keydown", async (event) => {
      const target = event.target;
      if (target instanceof HTMLElement) {
        if (target.closest("input, textarea, select, button, a, [contenteditable=\"true\"]")) return;
      }

      if (!activeTrack || !audio.src) return;

      if (event.code === "Space") {
        event.preventDefault();
        if (audio.paused) {
          try {
            await audio.play();
          } catch (error) {
            console.error("Beat preview playback failed.", error);
          }
        } else {
          audio.pause();
        }
        syncPlayerUI();
        return;
      }

      if (event.code === "ArrowLeft" && (event.altKey || event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        await playPrevious();
        return;
      }

      if (event.code === "ArrowRight" && (event.altKey || event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        await playNext();
        return;
      }

      if (event.code === "ArrowUp" && (event.altKey || event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        applyVolume((audio.muted ? 0 : audio.volume) + 0.05);
        return;
      }

      if (event.code === "ArrowDown" && (event.altKey || event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        applyVolume((audio.muted ? 0 : audio.volume) - 0.05);
      }
    });

    audio.addEventListener("timeupdate", () => {
      if (isClosingPlayer) return;
      updateProgress();
      updateTimeDisplay();
    });

    audio.addEventListener("loadedmetadata", () => {
      if (isClosingPlayer) return;
      updateTimeDisplay();
      updateProgress();
    });

    audio.addEventListener("play", syncPlayerUI);
    audio.addEventListener("pause", syncPlayerUI);

    audio.addEventListener("ended", async () => {
      if (isClosingPlayer) return;

      const visibleRows = getVisiblePlayableRows();
      const currentIndex = visibleRows.indexOf(activeRow);
      if (currentIndex !== -1 && currentIndex < visibleRows.length - 1) {
        await loadRow(visibleRows[currentIndex + 1], true);
        return;
      }

      audio.currentTime = 0;
      syncPlayerUI();
    });

    if ("mediaSession" in navigator) {
      navigator.mediaSession.setActionHandler("play", async () => {
        if (!activeTrack || !audio.src) return;
        try {
          await audio.play();
        } catch (error) {
          console.error("Beat preview playback failed.", error);
        }
      });

      navigator.mediaSession.setActionHandler("pause", () => {
        if (!activeTrack || !audio.src) return;
        audio.pause();
      });

      navigator.mediaSession.setActionHandler("previoustrack", () => {
        if (!activeTrack || !audio.src) return;
        playPrevious();
      });

      navigator.mediaSession.setActionHandler("nexttrack", () => {
        if (!activeTrack || !audio.src) return;
        playNext();
      });
    }

    updatePlayIcons(false);
    updateVolumeIcon();
    syncButtons();

    if (playerData.previewCount === 0) {
      trackName.textContent = "Previews unavailable";
      trackMeta.textContent = "Add preview audio in product metafields to enable playback.";
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBeatPlayer, { once: true });
  } else {
    initBeatPlayer();
  }
})();
